export default "__VITE_PUBLIC_ASSET__29f34bb3__"